/**
 * Maintenance mode flag for the portal.
 *
 * Driven entirely by the GATSBY_MAINTENANCE_MODE environment variable so the
 * whole portal can be swapped for a maintenance screen from the hosting
 * dashboard's environment settings, without editing or re-releasing source.
 *
 * Defaults to OFF: an unset, empty, or unrecognised value leaves the portal
 * rendering exactly as it does today.
 *
 * Accepted "on" values (case-insensitive): true, 1, on, yes, enabled.
 */
const ENABLED_VALUES = ['true', '1', 'on', 'yes', 'enabled'];

// Note: Gatsby inlines GATSBY_-prefixed variables at build time, so this has to
// read the full `process.env.GATSBY_MAINTENANCE_MODE` expression literally.
const isMaintenanceMode = () =>
    ENABLED_VALUES.includes(
        String(process.env.GATSBY_MAINTENANCE_MODE || '').trim().toLowerCase()
    );

export default isMaintenanceMode;
